export const updateTco = (target, value) => {
    return {
        type: "UPDATE_TCO",
        payload: {
            target: target,
            value: value,
        },
    };
};

export const updateInitialTco = (target, value) => {
    return {
        type: "UPDATE_INITIAL_TCO",
        payload: {
            target: target,
            value: value,
        },
    };
};



// WEBPACK FOOTER //
// ./src/actions/actions-tco.js